
import { useLocation} from 'react-router-dom';
import React, { useEffect } from 'react';
import BuilderService from '../services/BuilderService';
import { AxiosError } from 'axios';
import { useUpdateUserDetails } from '../../redux/hooks/UserDetails';

function Protected({ children }: { children: React.ReactNode }) {
  const {  updateUserDetail } = useUpdateUserDetails();
  const builderService = new BuilderService();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const querytoken = queryParams.get('auth');
  const fetchUser = async () => {
    const updateuser = await builderService.getUser();
    return updateuser;
  };

  useEffect(() => {
    const fetchData = async () => {
      try{
        let fetchedUser =  await fetchUser();
        if (fetchedUser && fetchedUser.data) {
          updateUserDetail(fetchedUser.data);
        }
  
      } catch(error) {
        if (error && (error as AxiosError).response && (error as AxiosError).response!.status === 401) {
          // window.location.href = `${process.env.REACT_APP_REDIRECT_URL}`;
          console.log("Error in fetching user details11 redirecting", error);
          //redierct to home page
          window.location.href = '/login';
           
        }
      }
    };
    if (!querytoken && location.pathname !== '/preview') {
    fetchData();
   } 
  }, []);

  return <>{children}</>;
}

export default Protected;